import React from "react"
import types from "prop-types"
import clsx from "clsx"

const IconContainer = ({ ariaHidden = false, className = "w-8 h-8", children }) => (
  <div className={clsx(className, "grid place-items-center icon")} aria-hidden={ariaHidden}>
    { children }
  </div>
)

IconContainer.propTypes = {
  ariaHidden: types.bool,
  className: types.string,
  children: types.node.isRequired,
}

export default IconContainer
